import { useCallback, useState } from 'react';
import { isVerifyValid } from './isVerifyValid';
import { formatVerify } from './formatVerify';

export const useVerifyValue = (initial: string) => {
  const [value, setValue] = useState(initial);
  const [isValid, setIsValid] = useState(isVerifyValid(initial));

  const onChange = useCallback((newValue: string) => {
    const formatted = formatVerify(newValue);
    setValue(formatted);
    setIsValid(isVerifyValid(formatted));
  }, []);

  return {
    value,
    isValid,
    onChange,
  };
};
